import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The dash hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a bold electric-blue + lightning-yellow speedster
 * palette, set apart from the other heroes' rose/steel/violet. Choosing dash recolours the WHOLE kid shell:
 * the brand ramp drives buttons / meters / rings in electric blue, the canvas blooms to a sunny-sky wash, and
 * the hero stage takes a bright high-energy daytime blue. Every brand colour is paired with its own foreground.
 */
export const dashTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — electric blue. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light
  // text; `tint` is the softest fill; `glow-rgb` = #1F6FD6 for the coloured shadows.
  '--color-primary': '#1F6FD6',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#4F93E8',
  '--color-primary-deep': '#14508F',
  '--color-primary-tint': '#DEEBFC',
  '--color-primary-glow-rgb': '31 111 214',
  '--color-secondary': '#DCEBFF',
  '--color-secondary-fg': '#0F2C57',
  '--color-accent': '#FFC83D',
  '--color-accent-fg': '#3A2E00',
  // CANVAS — a cool blue bloom top-left, a warm sunny-yellow bloom bottom-right (a bright open-sky wash).
  '--canvas-a': '#DCEBFF',
  '--canvas-b': '#FFF3D6',
  // A bright energetic speed-sky (white text stays AA over it).
  '--sky-top': '#0f2f6b',
  '--sky-mid': '#2f6fd0',
  '--sky-low': '#8cc2f5',
  '--sky-glow': '#ffe79a',
  '--sky-fg': '#ffffff',
});
